/**
 *  Models what a response of a versioned config request should look like.
 */
export class VersionedConfigResponse {
  private _version!: string;
  private _config!: object;

  /**
   *
   * @param version
   * @param config - Stringified JSON of the configuartion object.
   */
  public constructor(version: string, config: object) {
    this.version = version;
    this.config = config;
  }

  public set version(v: string) {
    this._version = v;
  }

  public get version(): string {
    return this._version;
  }

  public set config(c: any) {
    this._config = c;
  }

  public get config(): object {
    return this._config;
  }
}
